import HeadingContainer from 'redux/containers/components/search/HeadingContainer'
import Results from 'components/search/Results'
import PaginationContainer from 'redux/containers/components/search/PaginationContainer'
import React, { useEffect, useRef } from 'react'
import { scrollTo } from 'front-end-core/helpers/document'
import { useSelector } from 'react-redux'
import selectPlaceholders from 'redux/selectors/selectPlaceholders'
import url from 'front-end-core/core/url'
import { SEARCH } from 'constants/controllers'

const PagedSearchResults = ({
  pageLimit,
  pageNumber,
  query,
  response,
  searchPhrase,
  searchType,
  flavour,
  setSearchResultsLoaded,
  setSearchResponse,
  isMobile,
  pageId,
  aol
}) => {
  useEffect(() => {
    setSearchResultsLoaded(true)
    return () => setSearchResultsLoaded(false)
  }, [])

  useEffect(() => {
    setSearchResponse(response)
  }, [response])

  return (
    response.resultCount > 0
      ? <SearchList {...{ pageLimit, pageNumber, query, response, searchPhrase, searchType, flavour, pageId, isMobile, aol }} />
      : <SearchEmpty {...{ response, searchPhrase }} />
  )
}

export const searchTitles = (flavour) => ({
  legislation: 'Search results - Legislation',
  qa: `Search results - Q&A${flavour === 'archive' ? ' (archived)' : ''}`,
  precedents: 'Search results - precedents',
  ca: 'Search results - News'
})

const SearchList = ({ aol, pageLimit, pageNumber, query, response, searchPhrase, searchType, flavour, pageId, isMobile }) => {
  const title = searchTitles(flavour)[searchType] || 'Search results'
  const { isSearchResultsLoaded } = useSelector(selectPlaceholders)
  const { facets, resultCount, results } = response
  const resultsOnPage = results.length

  const resultsSectionRef = useRef()

  const getLink = (pageNumber) => url(SEARCH, { aol, flavour, searchPhrase, searchType }, { ...query, p: pageNumber })

  useEffect(() => {
    isSearchResultsLoaded && scrollTo({ pageId, element: resultsSectionRef.current, useWindowScrollTo: isMobile })
  }, [pageNumber, resultsSectionRef, isSearchResultsLoaded])

  return (
    <section className='bg-ghost-grey' ref={resultsSectionRef}>
      <div className='layout-width-constraint'>
        <div className='bb b--lite-grey mb7'>
          <HeadingContainer
            {...{ resultsOnPage, facets, resultCount, pageLimit, pageNumber, query, searchPhrase, title }}
          />
          <Results {...{ results }} />
        </div>
        <PaginationContainer
          {...{ resultsOnPage, resultCount, pageLimit, pageNumber, query, searchPhrase, getLink }}
        />
      </div>
    </section>
  )
}

const SearchEmpty = ({ response, searchPhrase }) => (
  <section className='bg-ghost-grey'>
    <div className='layout-width-constraint'>
      <HeadingContainer
        facets={response.facets}
        key='heading'
        searchPhrase={searchPhrase}
        title='Search returned no results'
        resultCount={0}
      />
    </div>
  </section>
)

export default PagedSearchResults
